function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.517a.68.68 0 0 0 .678.677.68.68 0 0 0 .677-.677V2.579c0-.675.549-1.224 1.224-1.224h2.88l.91 2.277a2.47 2.47 0 0 0 2.306 1.562h3.97v5.777c0 .676-.549 1.224-1.224 1.224H8.58a.68.68 0 0 0-.678.678.68.68 0 0 0 .678.678h2.84A2.58 2.58 0 0 0 14 10.97V2.58A2.58 2.58 0 0 0 11.42 0H2.58A2.58 2.58 0 0 0 0 2.58zm11.423-3.162c.675 0 1.224.549 1.224 1.224v1.26h-3.97a1.12 1.12 0 0 1-1.048-.709l-.71-1.775h4.506z",
    fill: "#355C72",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.421c0 .572.312 1.103.81 1.38a1.61 1.61 0 0 0 1.6-.034l2.936-1.806c.465-.285.752-.802.752-1.346 0-.545-.29-1.062-.752-1.346L2.41 7.462a1.6 1.6 0 0 0-.83-.23c-.266 0-.534.065-.77.196-.498.28-.808.809-.808 1.38v3.613zm1.355-3.613c0-.176.194-.285.343-.192l2.936 1.807a.226.226 0 0 1 0 .384l-2.936 1.806a.225.225 0 0 1-.343-.192z",
    fill: "#355C72",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedia);
export default __webpack_public_path__ + "static/media/ic_media.910f4f358f8cee1d7f24a752ca5bf30a.svg";
export { ForwardRef as ReactComponent };